<div class="profile-container">
    <div class="">
        <div class="profile-content">
   
            <div class="row">
            
              <div class="col-lg-12 col-md-12 dataList" style="margin:0;padding: 0;">
                <!-- <div class="dataList-header">
                  <div class="dataList-header-left">
                    <h4>TICKETS POSTED BY ME</h4>
                  </div>
                  
                </div> -->

                <div class="header-block">
                  <div class="header-title">
                      <p>Tickets <span>Count: {{totalRecords}}</span></p>
                  </div>
                  <div class="add-block">
                 
                      <div class="search">
                          <form autocomplete="off" >
                              <input type="text" [ngModelOptions]="{standalone: true}" placeholder="Filter here" [(ngModel)]="searchFilter">
                          </form>
                          <i class="bi bi-search" ></i>
                      </div>
                  </div>
              </div>
                <div class="dataList-content" >
                  <table class="table">
                    <thead>
                      <tr>
                        <th style="width: 5%;">Id</th>
                        <th style="width: 12%;">Customer Id</th>
                        <th style="width: 18%;">Subject</th>
                        <th style="width: 15%;">Details</th>
                        <th style="width: 15%;">Status</th>
                        <th style="width: 10%;">Service</th>
                        <th style="width: 15%;">Exp End Date</th>
                        <th style="width: 10%;">Action</th>
                      </tr>
                    </thead>
                  </table>

                  <div *ngIf="!isLoading">
                    <div class="ticket-block-data" *ngFor="let ticket of data | filter: searchFilter | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: pageNumber,
                      totalItems: totalRecords
                      }">
                      <div class="ticket-header-block" >
                        <span style="width: 5%;padding: 8px;" [ngClass]="{'ticket-id-color': ticket.ticket.ticketExpEndDate < toDayDate && ticket.ticket.latestTicketStatus == 'OPEN'}">{{ticket.ticket.ticketId}} <i style="margin-left: 10px;" *ngIf="ticket.ticket.source == 'whatsapp'" class="bi bi-whatsapp"></i></span>
                        <span style="width: 12%;padding: 8px;">
                          {{ticket.ticket.customerID}} <br>
                          <span *ngIf="ticket.ticket.customerName != '' && ticket.ticket.customerName != null">({{ticket.ticket.customerName}})</span>
                          
                           
                        </span>
                        <span style="width: 18%;padding: 8px;">{{ticket.ticket.heading}}</span>
                        <span style="width: 20%;padding: 8px;" title="{{ticket.ticket.details}}">{{ticket.ticket.details  | slice:0:30}}</span>
                        <span style="width: 15%;padding: 8px;">{{ticket.ticket.latestTicketStatus}}</span>
                        <span style="width: 10%;padding: 8px;">{{ticket.ticket.customerType}}</span>
  
                        <span style="width: 15%;padding: 8px;" [ngClass]="{'ticket-id-color': ticket.ticket.ticketExpEndDate < ticket.ticket.ticketExpStartDate && ticket.ticket.latestTicketStatus == 'OPEN'}">{{ticket.ticket.ticketExpEndDate | date: 'mediumDate'}}</span>
                        <span style="width: 10%;padding: 8px;display: flex;justify-content: center;">
                      
      
                          <svg xmlns="http://www.w3.org/2000/svg" id="" style="margin: 0 10px" (click)="getTicketTaskByID(ticket.ticket.ticketId)" data-toggle="modal" data-target="#ticketview" width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                          </svg> 
      
                     
                          
                        </span>
                      </div>
                      <div class="ticket-tasks-b row" *ngFor="let task of ticket.taskList;let t = index">
                        <div class="col-md-2 col-lg-2">
                          <label *ngIf="t == 0" for="">Task Id</label>
                          <p>{{task.ttaskId}}</p>
                        </div>
                        <div class="col-md-3 col-lg-3">
                          <label *ngIf="t == 0" for="">Name</label>
                          <p>{{task.name}}</p>
    
                        </div>
                        <div class="col-md-2 col-lg-2">
                          <label *ngIf="t == 0" for="" [ngClass]="{'ticket-id-color': (task.assignedToUserName == '' || task.assignedToUserName == null) && ticket.ticket.latestTicketStatus == 'OPEN'}">Assigned To </label>
                          <p>{{task.assignedToUserName}}</p>
    
                        </div>
                        <div class="col-md-3 col-lg-3">
                          <label *ngIf="t == 0" for="">Task Exp End Date</label>
                          <p>{{task.taskExpEndDate | date : 'medium'}}</p>
    
                        </div>
                        <div class="col-md-2 col-lg-2">
                          <label *ngIf="t == 0" for="">Status</label>
                          <p>{{task.latestTaskStatus}}</p>
    
                        </div>
                      </div>
                 
                  </div>
                  </div>

          
                <div class="loader" *ngIf="isLoading">
                  <div class="spinner"></div>
              </div>
                <div class="pagination-block" *ngIf="data.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                  </div>
                  <div style="display: flex;justify-content: center;align-items: center;height: 200px;">
                    <h5 class="text-center" *ngIf="!isLoading && data.length == 0">no tickets</h5>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
  </div>
  
  <div class="modal fade" id="ticketview" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="task-content" *ngFor="let ticket of TicketData;">
          <div class="c-button">
            <div class="c-right">
              <h4>Ticket Id: #{{ticket.ticketId}}</h4>
            </div>
            <div style="align-items: center;display: flex;">
              <!-- <input type="text" name="" id=""> -->
              <p *ngIf="ticket.source != '' && ticket.source != null" class="t-source">Source: {{ticket.source}}</p>
            
              <svg xmlns="http://www.w3.org/2000/svg" (click)="cancelModel()" style="margin-left: 10px"  data-dismiss="modal" width="26" height="26" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </div>
          </div>
        <div class="task-data">
          <ul class="task-header1">
            <li style="width: 20%;">Customer ID	</li>
            <li style="width: 20%;">Service Type</li>
            <li style="width: 20%;">Subject</li>
            <!-- <li style="width: 25%;">Details	</li> -->
          
            <li style="width: 20%;">Status</li>
          </ul>
          <div class="task-table" style="margin-bottom: 10px;" >
            <ul>
              <li style="width: 20%;">{{ticket.customerID}}</li>
              <li style="width: 20%;"><span *ngIf="ticket.customerType != null && ticket.customerType != ''">{{ticket.customerType}}</span><span *ngIf="ticket.customerType == null || ticket.customerType == ''">--</span></li>
              <li style="width: 20%;">{{ticket.heading}}</li>
              <!-- <li style="width: 25%;">{{ticket.details}}</li> -->
              
              <li style="width: 20%;text-align: center;position: relative;background-color: white;">
                <div>
                  <p><span style="cursor: pointer;padding: 5px 10px;" class="NEW">{{ticket.latestTicketStatus}}</span></p>
                </div>
              </li>
            </ul>
          </div>
          <div class="details">
            <div>
              <span >Details</span> <span>: &nbsp;</span> <span>{{ticket.details}}</span>
            </div>
          
          </div>
          <div class="customer-details">
            <div class="details" *ngIf="ticket.customerPhNo != '' && ticket.customerPhNo != null">
              <span >Customer PhNo</span> <span>: &nbsp;</span> <span>{{ticket.customerPhNo}}</span>
            </div>
            <div class="details" *ngIf="ticket.customerName != '' && ticket.customerName != null">
              <span >Customer Name</span> <span>: &nbsp;</span> <span>{{ticket.customerName}}</span>
            </div>
          </div>
          
          <div class="taskTable">
            <div>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Exp start date</th>
                    <th scope="col">Exp end date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <!-- <td *ngIf="ticket.ticketExpStartDate != 0">{{ticket.ticketExpStartDate | date:'medium'}}</td>
                    <td *ngIf="ticket.ticketExpEndDate != 0">{{ticket.ticketExpEndDate | date:'medium'}}</td> -->
                    <td ><span *ngIf="ticket.ticketExpStartDate != 0 && ticket.ticketExpStartDate != null">{{ticket.ticketExpStartDate | date:'medium'}}</span><span *ngIf="ticket.ticketExpStartDate == 0 || ticket.ticketExpStartDate == null">--</span></td>
                    <td ><span *ngIf="ticket.ticketExpEndDate != 0 && ticket.ticketExpEndDate != null">{{ticket.ticketExpEndDate | date:'medium'}}</span><span *ngIf="ticket.ticketExpEndDate == 0 || ticket.ticketExpEndDate == null">--</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- <button class="add-note" (click)="noteDropdown()">Add Note</button> -->
  
          <div class="assignedToAndTags">
            <!-- <div class="assignedTo">
              <p> <span>Assign to</span> <span *ngIf="ticket.assignedTo != null || ticket.assignedTo != ''">: {{ticket.assignedToUserName}}</span> 
                  <span *ngIf="ticket.assignedTo == null || ticket.assignedTo == ''" (click)="addClass('assignedTo')" class="assignedToButton"> &nbsp; click here to assign</span>
                  <span *ngIf="ticket.assignedTo != null && ticket.assignedTo != ''" (click)="addClass('assignedTo')" class="assignedToButton"> &nbsp; click here to reassign</span>
            </p>
            </div> -->
            <!-- <div class="usersTaged">
              <p *ngIf="task.tagUsers.length == 0"> <span>Users taged</span> <span class="assignedToButton" (click)="addClass('usersTaged')">: &nbsp; click here to Tag Users</span></p>
              <p *ngIf="task.tagUsers.length != 0"> <span>Users taged</span> <span *ngFor="let user of task.tagUsers;let u = index"> <span *ngIf="u == 0">: &nbsp;</span>  {{user.userName}},</span></p>
            </div> -->
          </div>
        

          <div class="image-container">
            <div class="image-header image-header1">
              <h5>Images/Videos</h5>
              <i (click)="addTicketImageBtn()" class="bi bi-plus-circle"></i>
            </div>
            <div class="image-content-block">
              <div class="image-single">
                <div class="image-list" *ngFor="let image of ticket.image">
                  <img src="{{image}}" (click)="selectLargeImage(image)" alt="">
                  <div class="image-list-options">
                    <button (click)="updateImg(image)">remove</button>
                  </div>
                </div>
              </div>
              <div class="large-image-view" *ngIf="largeImage != ''">
                <img src="{{largeImage}}" alt="">
                <button (click)="selectLargeImage('')">close</button>
              </div>
              <!-- <div class="image-single" *ngFor="let video of task.video">
                <img src="assets/img/video-play-icon-hd-png.png" data-toggle="modal" data-target="#imageView" (click)="viewVideo(video)" alt="">
              </div> -->
            </div>

            <div hidden="true">
              <input #imageInput
                        type="file" id="add-TicketImage-btn"
                        accept="image/*" hidden="true"
                        (change)="onTicketChange($event)">
            </div>
          </div>
      
  
          <ul class="task-header" *ngIf="TicketTaskdata != null && TicketTaskdata.length != 0">
            <li style="width: 9%;">Task-Id</li>
            <li style="width: 9%;">Sl No</li>
            <li>Completed %</li>
            <li>Create on</li>
            <li style="width: 20%;text-align: center;">Status</li>
            <li></li>
          </ul>
  
  
  
          <div class="task-table" *ngFor="let task of TicketTaskdata;let i = index">
            <ul>
              <li style="width: 9%;">#{{task.ttaskId}}</li>
              <li style="width: 9%;">{{task.taskSlNo}}</li>
              <li style="padding-left: 20px">{{task.completedPercentage}} %</li>
              <li>{{task.createdDate | date}}</li>
              <li style="width: 20%;text-align: center;">{{task.latestTaskStatus | titlecase}}</li>
              <li><a (click)="addc(i)"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
              </svg></a></li>
            </ul>
            <div class="dropdown-data-show" id="{{i}}">
              <div class="assignedToAndTags">
  
                <div class="assignedTo">
                  <p> 
                    <span>Assign to</span> 
                    <span *ngIf="task.assignedToUserName != null && task.assignedToUserName != ''">: &nbsp; {{task.assignedToUserName}}</span>

                  </p>
                </div>
                <!-- <div class="usersTaged">
                  <p> <span>Users taged</span> <span *ngFor="let user of task.tagUsers;let u = index"> <span *ngIf="u == 0">: &nbsp;</span>  {{user.userName}},</span></p>
                </div> -->
              </div>
              <!-- <div class="dataTablesContent">
                <div class="left">
                  <p><span>Listing number</span> <span>: &nbsp; {{task.taskListingNumber}}</span></p>
                  <p><span>SI number</span> <span>: &nbsp; {{task.taskSINumber}}</span></p>
                  <p><span>SL number</span> <span>: &nbsp; {{task.taskSlNo}}</span></p>
                </div>
                <div class="right">
                  <p> <span>Reg id</span> <span>: &nbsp; {{task.taskRegId}}</span></p>
                  <p> <span>Reg type</span> <span>: &nbsp; {{task.taskRegType}}</span></p>
                </div>
              </div> -->
              <p class="task-description"><span>Subject :</span> {{task.name}}</p>
  
              <div class="details">
                <p class="task-description"><span>Description :</span> {{task.description}}</p>
  
          
              </div>
  
              
              <div class="taskTable" style="padding: 0 10px;">
                <div >
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Exp start date</th>
                        <th scope="col">Exp end date</th>
                        <th scope="col">Act Start Date</th>
                        <th scope="col">Act End Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td ><span *ngIf="task.taskExpStartDate != 0 && task.taskExpStartDate != null">{{task.taskExpStartDate | date:'medium'}}</span><span *ngIf="task.taskExpStartDate == 0 || task.taskExpStartDate == null">--</span></td>
                        <td ><span *ngIf="task.taskExpEndDate != 0 && task.taskExpEndDate != null">{{task.taskExpEndDate | date:'medium'}}</span><span *ngIf="task.taskExpEndDate == 0 || task.taskExpEndDate == null">--</span></td>
                        <td ><span *ngIf="task.taskActStartDate != 0 && task.taskActStartDate != null">{{task.taskActStartDate | date:'medium'}}</span><span *ngIf="task.taskActStartDate == 0 || task.taskActStartDate == null">--</span></td>
                        <td ><span *ngIf="task.taskActEndDate != 0 && task.taskActEndDate != null">{{task.taskActEndDate | date:'medium'}}</span><span *ngIf="task.taskActEndDate == 0 || task.taskActEndDate == null">--</span></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- <p class="task-description"><span>Note :</span> The lorem generator is nice but it’s code completing functionality makes it indispensable. Once you learn the syntax you can code a whole wireframe with just a few keystrokes.</p> -->
  
              <!-- <div class="taskTable">
                <div>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Act duration</th>
                        <th scope="col">Act end date</th>
                        <th scope="col">Act start date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{task.taskActDuration | date}}</td>
                        <td>{{task.taskActEndDate | date}}</td>
                        <td>{{task.taskActStartDate | date}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
  
                <div>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Exp duration</th>
                        <th scope="col">Exp end date</th>
                        <th scope="col">Exp start date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{task.taskExpDuration | date}}</td>
                        <td>{{task.taskExpEndDate | date}}</td>
                        <td>{{task.taskExpStartDate | date}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div> -->
  
  
            </div>
          </div>
        </div>
        </div>
  
  
        <div class="modal-footer" hidden="true">
          <button type="button" id="closeModalButton12" class="btn btn-secondary" data-dismiss="modal" class="btn btn-secondary">Cancel</button>
        </div>
      </div>
    </div>
  </div>